const getBenefits = (partnerName: string) => [
  'Email, phone, and text',
  `Hide ${partnerName} branding`,
  'Full chatbot customizations',
  'And much more!',
]

export default getBenefits
